import Vue from 'vue'
import InputText from './InputGeneric.vue'
import InputTexto from './InputTexto.vue'
import InputHoraEMinuto from './inputHoraEMinuto/InputHoraEMinuto.vue'

Vue.component('InputText', InputText)
Vue.component('InputTexto', InputTexto)
Vue.component('InputHoraEMinuto', InputHoraEMinuto)
